import { render } from "./GetStartedView.vue?vue&type=template&id=92b49264&scoped=true"
import script from "./GetStartedView.vue?vue&type=script&lang=js"
export * from "./GetStartedView.vue?vue&type=script&lang=js"

import "./GetStartedView.vue?vue&type=style&index=0&id=92b49264&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b49264"]])

export default __exports__